<div class="type">
  <mat-icon class="material-symbols-outlined type__icon">{{ type === 'Person' ? 'person' : 'domain' }}</mat-icon>
  <div class="type__name">{{ type }}</div>
</div>
